import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
    subTitle: {
        fontSize: '1.4em',
        marginTop: theme.spacing(1),
    },
}));

function BidInformation({ group, periodsBidding, daysToBid }){
    const classes = useStyles();

    return (
        <>
        <div className={classes.subTitle}>Bid Information</div>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
                <TextField
                    label="Group"
                    name="group"
                    value={group}
                    margin="dense"
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <TextField
                    label="Periods Bidding"
                    name="periodsBidding"
                    value={periodsBidding}
                    margin="dense"
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <TextField
                    label="Days To Bid"
                    name="daysToBid"
                    value={daysToBid}
                    margin="dense"
                    fullWidth
                    disabled
                />
            </Grid>
        </Grid>
        </>
    );
};

BidInformation.propTypes = {
    group: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]).isRequired,
    periodsBidding: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]).isRequired,
    daysToBid: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]).isRequired,
};

export default BidInformation;
